import { Dropdown } from "react-bootstrap";
import { getAccountCurrencyExchangeRateByCurrencyExchangeRateIdAsync, deleteAccountCurrencyExchangeRateAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState,updateSorting } from "./CurrencyExchangeRateSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import moment from "moment";
import { formatDateWithDateAndMonthName, dateFormatByAccountCulture, getValueFromResource,FormatNumberCultureAware } from "../../../common/timeLiveFunction";
const itemClass = 'ms-1 ms-lg-0';
export const CurrencyExchangeRateItem = (props: any) => {
    const dispatch = useAppDispatch();
    const { CurrencyExchangeRateList, t, onopenModal, IsEdit, IsDelete } = props;
    const { sortOrder, sortColumn, pageSize } = useAppSelector((state) => state.currencyExchangeRate);
    const { cultureInfoName } = useAppSelector((state) => state.globalState);
    

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };
    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };
    const onEditClick = (AccountCurrencyExchangeRateId: number) => {
        dispatch(getAccountCurrencyExchangeRateByCurrencyExchangeRateIdAsync(AccountCurrencyExchangeRateId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    const onDeleteClick = (AccountCurrencyExchangeRateId: any) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountCurrencyExchangeRateAsync(AccountCurrencyExchangeRateId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                            ShowToast("Currency Exchange Rate Delete Successfully", 'Success', "success", "toast-top-right") :
                            ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                    {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    checked={CurrencyExchangeRateList.every((item: any) => item.isSelected === 0) ? false :
                                        (CurrencyExchangeRateList.every((item: any) => item.isSelected === 1 ? true : false))
                                    }
                                    onChange={handleSelectAllChange}
                                />
                            </div>
                        </th>
}
                          <th style={{ width: '30%' }}>
                            {/* {t('Exchange Rate')} */}
                            {getValueFromResource('Exchange Rate',dispatch, t)}
                        {sortColumn === 'ExchangeRate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ExchangeRate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ExchangeRate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ExchangeRate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ExchangeRate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '30%' }}>
                            {/* {t('Start Date')} */}
                            {getValueFromResource('Start Date',dispatch, t)}
                        {sortColumn === 'ExchangeRateEffectiveStartDate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ExchangeRateEffectiveStartDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ExchangeRateEffectiveStartDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ExchangeRateEffectiveStartDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ExchangeRateEffectiveStartDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '25%' }}>
                            {/* {t('End Date')} */}
                            {getValueFromResource('End Date',dispatch, t)}
                        {sortColumn === 'ExchangeRateEffectiveEndDate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ExchangeRateEffectiveEndDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ExchangeRateEffectiveEndDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ExchangeRateEffectiveEndDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ExchangeRateEffectiveEndDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-0'></th>
                    </tr>
                </thead>
                <tbody>
                    {CurrencyExchangeRateList.length === 0 && <tr><td colSpan={5}><p className='noDataFound mt-3'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}
                        </p></td></tr>}
                    {CurrencyExchangeRateList.length > 0 && CurrencyExchangeRateList.map((currencyExchangeRateDetail: any, i: any) => (
                        <tr key={i}>
                            {IsDelete &&
                            <td>
                               <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        type="checkbox"
                                        className="form-check-input widget-9-check"
                                        checked={currencyExchangeRateDetail.isSelected == 0 ? false : true}
                                        onChange={(e) => { handleCheckboxChange(e, currencyExchangeRateDetail.AccountCurrencyExchangeRateId) }}
                                    />
                                </div>
                            </td>
}
                            <td>
                                <span className="d-block">
                                    {FormatNumberCultureAware(cultureInfoName.toString(), currencyExchangeRateDetail.ExchangeRate)}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {formatDateWithDateAndMonthName(currencyExchangeRateDetail.ExchangeRateEffectiveStartDate, cultureInfoName.toString())}
                                    {/* {new Date(currencyExchangeRateDetail.ExchangeRateEffectiveStartDate).toLocaleDateString()} */}
                                    {/* {moment.parseZone(dateFormatByAccountCulture(currencyExchangeRateDetail.ExchangeRateEffectiveStartDate, cultureInfoName.toString())).format('DD MMM yy')} */}
                                    {/* {new Date(currencyExchangeRateDetail.ExchangeRateEffectiveStartDate).toLocaleDateString('en-US', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                    })} */}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {/* {new Date(currencyExchangeRateDetail.ExchangeRateEffectiveEndDate).toLocaleDateString()} */}
                                    {/* {moment.parseZone(dateFormatByAccountCulture(currencyExchangeRateDetail.ExchangeRateEffectiveEndDate, cultureInfoName.toString())).format('DD MMM yy')} */}
                                    {formatDateWithDateAndMonthName(currencyExchangeRateDetail.ExchangeRateEffectiveEndDate, cultureInfoName.toString())}
                                </span>
                            </td>
                            <td className='text-center' >
                                <div className={clsx('app-navbar-item', itemClass)}>
                                            <Dropdown
                                                style={{ marginLeft: 1 }}
                                                className={clsx('cursor-pointer symbol')}   
                                                data-kt-menu-attach='parent'
                                                data-kt-menu-placement='bottom-end'
                                            >
                                                <Dropdown.Toggle
                                                    variant="transparent"
                                                    className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                    data-tooltip-id="tooltip-Description"
                                                    data-tooltip-content=
                                                    // {t("More")}
                                                    {getValueFromResource('More',dispatch, t)}
                                                    data-tooltip-place="top"
                                                >
                                                    <i className="bi bi-three-dots fs-7 " ></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu
                                                     className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                    {IsEdit &&
                                                        <>
                                                            <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => { onEditClick(currencyExchangeRateDetail.AccountCurrencyExchangeRateId) }}
                                                                >
                                                                    <span className="menu-icon custom-menu">
                                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {/* {`${t('Edit')}`} */}
                                                                        {getValueFromResource('Edit',dispatch, t)}
                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        </>
                                                    }
                                                    {IsDelete && IsEdit &&
                                                        <div className='separator mb-1 mt-1 opacity-75 '></div>
                                                    }
                                                    {IsDelete &&
                                                        <>
                                                            <div className='menu-hover-bg-danger'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => { onDeleteClick(currencyExchangeRateDetail.AccountCurrencyExchangeRateId) }}>
                                                                    <span className="menu-icon  custom-menu">
                                                                        <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                        {/* {`${t('Delete')}`} */}
                                                                        {getValueFromResource('Delete',dispatch, t)}

                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>
                                                        </>
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                </div>
                            </td>
                        </tr>
                    ))}

                </tbody>
            </table >
        </>
    )
}


